import React, { Component } from 'react';
import { colors, Spinner } from '@cimpress/react-components';

export default class SpinnerDemo extends Component {
  state = {
    spinnerHidden: false,
    showFullPage: false,
    offset: 0,
  };

  toggleFullPage = () => {
    this.setState(prevState => ({ showFullPage: !prevState.showFullPage }));
  };

  toggleSlowSpinner = () => {
    this.setState(prevState => ({ spinnerHidden: !prevState.spinnerHidden }));
  };

  handleSpinnerOffset = offset => {
    this.setState(prevState => ({ offset: (offset + prevState.offset) % 1 }));
  };

  render() {
    const { spinnerHidden, offset } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-4">
            Large (default) Size (72px):
            <Spinner />
          </div>
          <div className="col-md-4">
            Medium (38px):
            <Spinner size="medium" />
          </div>
          <div className="col-md-4">
            Small Size (16px):
            <Spinner size="small" />
          </div>
        </div>
        <div className="row" style={{ paddingTop: '15px' }}>
          <div className="col-md-4">
            Default Duration (2):
            <Spinner />
          </div>
          <div className="col-md-4">
            <div>Full Page Center:</div>
            <button onClick={this.toggleFullPage} className="btn btn-primary">
              Show spinner
            </button>
            {this.state.showFullPage ? <Spinner fullPage /> : ''}
          </div>
          <div className="col-md-4">
            Fast Duration (1):
            <Spinner duration={1} />
          </div>
        </div>
        <div className="row" style={{ paddingTop: '15px' }}>
          <div className="col-md-4">
            <div>Slow Duration (8):</div>
            <div>Utilize the offset feature to minimize jitter.</div>
            {spinnerHidden ? (
              <div
                style={{
                  height: '72px',
                  width: '72px',
                  fontSize: '22px',
                  color: colors.platinum,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {Math.round(this.state.offset * 100)}%
              </div>
            ) : (
              <Spinner duration={8} offset={offset} handleOffset={this.handleSpinnerOffset} />
            )}
            <button onClick={this.toggleSlowSpinner} className="btn btn-primary">
              {this.state.spinnerHidden ? 'Reveal' : 'Hide'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
